import {useMemo} from 'react'

import {formatBuildNumber} from '../components/common/BuildNumber/BuildNumber.utils'
import {getBuild} from '../selectors'
import type {BuildId} from '../types'
import {displayDate} from '../utils/dateTimeUtils'

import {useAppSelector} from './react-redux'
import {useIsAutodetectTimeZone} from './useIsAutodetectTimeZone'

export function useBuildTitle(buildId?: BuildId | null) {
  const build = useAppSelector(state => getBuild(state, buildId))
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  return useMemo(() => {
    const {number, history, queuePosition, state} = build ?? {}
    const queued = state === 'queued'
    const formattedBuildNumber = formatBuildNumber({
      number,
      isQueued: queued,
      queuePosition,
    }).text

    if (history === true) {
      return `History ${formattedBuildNumber}`
    }

    const {startDate = null, queuedDate = null} = build ?? {}

    if (state === 'queued') {
      const queuedDateText =
        queuedDate != null ? ` ${displayDate(queuedDate, isAutodetectTimeZone, true)}` : ''
      return `Queued${queuedDateText}`
    }

    const startDateText =
      startDate != null ? ` at ${displayDate(startDate, isAutodetectTimeZone, true)}` : ''
    return `${formattedBuildNumber}${startDateText}`
  }, [build, isAutodetectTimeZone])
}
